<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
      <!-- <sm-title-bar pageTitle="All inventory status"></sm-title-bar> -->
      <sm-title-bar pageTitle="All inventory status" [showBackToDashboard]="true"></sm-title-bar>

    </div>
  </div>
  <div class="col-sm-3">
    <!-- <div class="search_bar_custom">
      <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search for services">
          <button mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
  </div> -->
  </div>
</div>

<div class="" *ngIf="!loader">
  <div class="row">
    <div class="col-md-6 col-sm-6 col-12" *ngFor="let data of inventoryStatusData">
    <div class="plan-card" >
      <!-- <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 15px; top: 2px;">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu2="matMenu">
        <button mat-menu-item (click)="viewDetails(data)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>{{ 'pay_credits.op1_view_details' | translate }}</span>
        </button>
        <button mat-menu-item (click)="addPayback(data)">
          <mat-icon class="material-icons-outlined">add</mat-icon>
          <span>{{ 'pay_credits.op2_add_payback' | translate }}</span>
        </button>
        <button mat-menu-item (click)="deleteCredit(data)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>{{ 'pay_credits.op3_delete' | translate }}</span>
        </button>
      </mat-menu> -->
      <div class="d-flex align-items-center" style="position:relative ;">
        <mat-icon
        *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'"

        [ngStyle]="{'background-color': data.current_purchase_stock <= 0 || data.current_purchase_stock == null
    ? 'red'
    : data.current_purchase_stock > 0 && data.current_purchase_stock <= data.min_stock
        ? 'yellow'
        : 'green'}"
            class="status-icon"
           
           
          ></mat-icon>
        <div class="booking-initial" *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'">{{data.item_name.slice(0,1).toUpperCase()}}</div>
        <div class="" style="position: relative;flex-shrink: 0;" *ngIf="data.image_thumb_url && data.image_thumb_url != 'null'">
          <img style="height: 50px;width: 50px;" [src]="data.image_thumb_url" onerror="this.src='../../../../../assets/images/purchase-placeholder.jpeg'"
          alt="" class="img-fluid rounded-circle booking-initial-img">
          <span style="height: 15px; width: 15px; background-color: red; border-radius: 50%; display: block; position: absolute;
          bottom: 0px;
          right: 0px;"

            [ngStyle]="{'background-color': data.current_purchase_stock <= 0 || data.current_purchase_stock == null
    ? 'red'
    : data.current_purchase_stock > 0 && data.current_purchase_stock <= data.min_stock
        ? 'yellow'
        : 'green'}"></span>
        </div>
        <div class="m-1 data_list_r">
          <h2 class="plan-title"> {{ data.item_name }}</h2>
          <p class="plan-info">
            <span class="valuestock">{{ data.s_q_info }}, Current stock: {{data.stock}}</span>
            <!-- <span class="label">Type: </span> <span class="value">{{ data.payment_mode1 }} </span>, -->
          </p>
        </div>
      </div>
      <!-- <div class="m-2" style="margin-bottom: 0px !important;margin-left: 0px !important;">
        <p class="plan-cost">
          <span class="value"></span>
        </p>
      </div> -->
      <div class="m-2" style="margin-bottom: 0px !important;margin-left: 0px !important;">
        <p class="plan-cost">
          <span class="value">{{data.name}}</span>
        </p>
      </div>
      <p class="plan-cost">
        <span class="label">{{ data.address_line | ellipsify:45 }}</span>
      </p>
    </div>
    </div>
  </div>
</div>

<!-- old tables codex -->
<!-- <mat-card appearance="outlined" *ngIf="!loader && inventoryStatusData.length > 0">
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [showImageColumn]="true" [imageTemplate]="image"
      [dataSource]="inventoryStatusData" [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card>

<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span>Edit</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">delete</mat-icon>
    <span>Delete</span>
  </button>
</ng-template>

<ng-template #image let-objValue>
  <img [src]="
          objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
            ? objValue['image_thumb_url']
          : './assets/images/salon_support_header.png'
        " class="img-fluid rounded-circle" />
  <span style="height: 15px; width: 15px; background-color: red; border-radius: 50%; display: block; position: relative;bottom: 12px;
    left: 28px;" [ngStyle]="{'background-color': objValue['current_purchase_stock'] == 0 || objValue['current_purchase_stock'] == null
    ? 'red'
    : objValue['current_purchase_stock'] > 0 && objValue['current_purchase_stock'] <= objValue['min_stock']
        ? 'yellow'
        : 'green'}">

  </span>
</ng-template> -->